export default __webpack_public_path__ + "static/media/mission.ddd64dab.svg";